





import Vue from 'vue';
import Component from 'vue-class-component';
import { DxButton } from 'devextreme-vue';
@Component({
  components: {
  }
})
export default class Home extends Vue {
}
